import { StyledCard } from "./styled/Card.styled";

const Card = () => {
  return (
    <StyledCard>
      <div>
        <h2>New Xpander "Be The Life Xpander"</h2>
        <p>
          New Xpander hadir dengan New Bumper & Grille Design yang lebih
          atraktif, dan juga lampu utama baru dengan desain T-Shape, memberikan
          pencahayaan terbaik dalam berkendara.
        </p>
      </div>

      <div>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/bxMI4Ev3tmM"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </StyledCard>
  );
};

export default Card;
